export const sliderData = [
    {
      id: "1",
      number: "60%",
      title: "MERN Stack",
      desc:
        " of all full-stack projects are made with MERN stack which is one of TOP 3 stacks for 2022. ",
      img:
        "./assets/MERN.png",
    },
    {
      id: "2",
      number: "20%",
      title: "MEAN Stack",
      desc:
        " of all full-stack projects are made with MEAN stack which is one of TOP 3 stacks for 2022.",
      img:
        "./assets/MEAN.png",
    }
  ];

export const tilesData = [
  {
    id: "1",
    icon: "devicon-react-original",
    title: "React"
  },
  {
    id: "2",
    icon: "devicon-angularjs-plain",
    title: "Angular"
  },
  {
    id: "3",
    icon: "devicon-redux-original",
    title: "Redux"
  },
  {
    id: "4",
    icon: "devicon-javascript-plain",
    title: "JavaScript"
  },
  {
    id: "5",
    icon: "devicon-html5-plain",
    title: "HTML5"
  },
  {
    id: "6",
    icon: "devicon-css3-plain",
    title: "CSS3"
  },
  {
    id: "7",
    icon: "devicon-mongodb-plain",
    title: "MongoDB"
  },
  {
    id: "8",
    icon: "devicon-sass-original",
    title: "Sass"
  },
  {
    id: "9",
    icon: "devicon-bootstrap-plain",
    title: "Bootstrap"
  },
  {
    id: "10",
    icon: "devicon-mysql-plain",
    title: "MySQL"
  },

]